import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';
import { MessageInfoStoreProvider } from '../../providers/message-info-store/message-info-store';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ConfigDataProvider } from '../../providers/config-data/config-data';

@Component({
	selector: 'message-info-panel',
	templateUrl: 'message-info-panel.html'
})
export class MessageInfoPanelComponent {

	private messageId = "";
	private conversationId = "";
	private shouldStopSubscription: Subject<any> = new Subject();
	private currentUser = null;
	private messageInfoDetailList = [];


	constructor(
		private viewCtrl: ViewController,
		private navParams: NavParams,
		private messageInfoStore: MessageInfoStoreProvider,
		private configDataProvider: ConfigDataProvider
	) {

		this.currentUser = this.configDataProvider.getUserData();
		this.messageId = this.navParams.get("messageId");
		this.conversationId = this.navParams.get("conversationId");

		this.loadMessageInfo(this.conversationId, this.messageId);

	}

	loadMessageInfo(conversationId, messageId) {


		this.messageInfoStore.loadMessageForMessageInfoPanel(conversationId, messageId)
			.pipe(takeUntil(this.shouldStopSubscription))
			.subscribe((messages) => {

				if(messages && messages.id){

					if(messages.readresult && messages.readresult.length > 0) {
						this.messageInfoDetailList = messages.readresult;
					}

				}

			}, () => {

			})


	}

	closeModal() {
		this.viewCtrl.dismiss();
	}

}



// WEBPACK FOOTER //
// ./src/components/message-info-panel/message-info-panel.ts